import React from 'react';
import epicTracking from 'epic-tracking';
import root from 'window-or-global';

export const useDownload = (info) => {
    return React.useCallback(() => {
        epicTracking.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'Download',
            eventAction: 'ios'
        });
        root.location.href = info.iosLink;
    }, [info]);
}
